import CheckoutProductRow from '@/js/checkout-product-row';
[].forEach.call(document.querySelectorAll('[data-js-checkout-product-row]'), (element: any) => {
    new CheckoutProductRow(element);
});
